<div #header id="header" class="container noprint mb-2 py-1 sticky-top">
  <div class="row">
    <div class="col col-6 col-lg-3 order-1">
      <a routerLink="/" title="ABMP CE Center Home" class="d-flex w-100" id="header-image-link">
        <img id="logoround" src="https://learn.cdn.abmp.com/public/ng/lms-logo-round.svg" class="d-inline mr-2" width="110" height="110" />
        <img id="logotext" src="https://learn.cdn.abmp.com/public/ng/lms-logo-text.svg" class="d-inline" width="160" height="148" />
      </a>
    </div>
    <div class="col col-12 col-lg-6 order-3 order-lg-2 pr-0">
      <nav id="headernav" class="navbar navbar-expand-md mt-lg-3 text-uppercase font-weight-bold text-nowrap">
        <div class="d-flex flex-row justify-content-between">
          <ul class="navbar-nav flex-row w-100 justify-content-between justify-content-lg-start">
            <li class="nav-item"><a class="nav-link" [routerLink]="['/']" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}">Dashboard</a></li>
            <li class="nav-item"><a class="nav-link" [routerLink]="['/courses']" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}">
                <span class="d-none d-lg-inline">Course List</span>
                <span class="d-inline d-lg-none">Courses</span>
              </a></li>
            <li class="nav-item" *ngIf="bundles.length > 0"><a class="nav-link" [routerLink]="['/packages']"
                routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Packages</a></li>
          </ul>
          <button class="navbar-toggler" type="button" (click)="navCollapsed = !navCollapsed;">
            <fa-icon icon="ellipsis-h"></fa-icon>
          </button>
        </div>
        <div [ngbCollapse]="navCollapsed" class="collapse navbar-collapse pr-4">
          <ul class="navbar-nav w-100 flex-column flex-md-row justify-content-end">
            <li class="nav-item text-right" *ngIf="ucdService.IsLoggedIn"><a class="nav-link"
                [routerLink]="['/transcript']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="navCollapsed = true">My
                CE</a></li>
            <li class="nav-item text-right"><a class="nav-link" [routerLink]="['/help', 'faq']" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}" (click)="navCollapsed = true">FAQ</a></li>
          </ul>
        </div>
      </nav>
    </div>
    <div class="col col-6 col-lg-3 d-flex flex-row-reverse order-2 order-lg-3">
      <app-header-userinfo class="d-block mt-4" *ngIf="ucdService.IsLoggedIn; else loginForm"></app-header-userinfo>
      <ng-template #loginForm>
        <app-header-loginform class="d-block mt-4"></app-header-loginform>
      </ng-template>
    </div>
  </div>
</div>